import { connect } from 'react-redux'
import PlayInScreen from './PlayInScreen'
import playInActions from '../../dataStore/actions/playIns'
import selectExternalMediaPresenter from '../../dataStore/selectors/selectExternalMediaPresenter'
import { State } from '../../dataStore/reducers/reducerType'
import { setAutoSpotlight, setMediaType } from '../../dataStore/actions/room/room'
import { OBSERVER } from '../../dataStore/constants/roles'
import { mediaType as MediaType } from '@bt-react/constants'
import { PlayInScreenProps } from './types'
import * as PlayIn from '../../lib/playIn'
import username from '../../lib/username'

const makeMapStateToProps = () => {

  const getExternalMediaPresenter = selectExternalMediaPresenter()

  type Dispatch = 'onStop'

  const mapStateToProps = (state: State, props): Omit<PlayInScreenProps, Dispatch> => ({
    ...props,
    BTID: state.user.BTID,
    currentPos: state.playIn.currentPos,
    currentPosTimestamp: state.playIn.currentPosTimestamp,
    isBridgeInstance: state.config.bridgeName !== '',
    bridgeName: state.config.bridgeName,
    isMediaPresenter: getExternalMediaPresenter(state),
    pausedAt: state.playIn.pausedAt || undefined,
    playIn: state.room.playIn as PlayIn.default,
    remoteStatusRequest: state.playIn.remoteStatusRequest,
    showControls: !username.isWatchScreen(state.config.username ?? ''),
    status: state.playIn.status,
    sources: state.playIn.sources,
    isObserver: state.config.role === OBSERVER,
    layoutsActive: state.layouts.presenterLayout.presenterLayoutsActive,
    isMuted: props.isMuted
  })

  return mapStateToProps

}

const mapDispatchToProps = dispatch => ({
  onStop: (layoutsActive?: boolean) => {
    if (layoutsActive) {
      dispatch(setAutoSpotlight(true))
      dispatch(setMediaType(MediaType.SPOTLIGHT))
    }
    dispatch(playInActions.stopPlayIn(layoutsActive))
  }
})

export default connect(makeMapStateToProps, mapDispatchToProps)(PlayInScreen)
